<template>
  <div class="rails">
    <TG4Loader v-if="CMSRailManager.state.value === 'loading'" />

    <div v-else-if="CMSRailManager.state.value === 'error'" class="rails-error">
      <h1>{{ $t('general.error') }}</h1>
      <TG4Button id="rail-0-0" :title="$t('general.retry')" v-focus v-focus-on-insert v-press="retryLoad" />
    </div>

    <RailsContainer v-else topFocusId="nav-home" rememberFocus :rails="CMSRailManager.rails.value ?? []"/>

  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, nextTick, watch, getCurrentInstance } from 'vue';
import { navigationService } from "vue-spatialnavigation";
import { CMSRailManager } from "@/services/CMSRailManager";
import { focusElementById, nothingHasFocus } from '@/helpers/focus';
import { railFocusMemory } from '@/helpers/railFocusMemory';
import TG4Loader from '@/components/TG4Loader.vue';
import TG4Button from '@/components/TG4Button.vue';
import RailsContainer from '@/components/containers/RailsContainer.vue';

const instance = getCurrentInstance();

const retryLoad = () => {
  CMSRailManager.refreshRails();
};


const claimFocusIfLost = () => {
  if (!nothingHasFocus()) return;

  const remembered = `rail-${railFocusMemory.get()}-0`;

  focusElementById(remembered, { scroll: true })
    || focusElementById('rail-0-0', { scroll: true })
    || focusElementById('nav-home');
};

onMounted(async () => {
  navigationService.blockAllSpatialNavigation = true;
  instance?.proxy?.$recordEvent('home-view-selected');
  setTimeout(() => {
    navigationService.blockAllSpatialNavigation = false;
  }, 300);

  claimFocusIfLost();

  CMSRailManager.startPolling();
});


watch(() => CMSRailManager.rails.value, () => nextTick(claimFocusIfLost));

onBeforeUnmount(() => {
  CMSRailManager.stopPolling();
});




</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.rails {
  // No horizontal padding: rails are full-bleed so a rail's backgroundColor
  // paints edge to edge. Each rail owns its own left gutter instead, which is
  // also what the horizontal scroll maths aligns focused cards to.
  padding: 40px 0;
  color: $color-text-white;
  text-align: left;
}

.rails-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 200px 0;

  h1 {
    font-size: 40px;
    margin-bottom: 30px;
  }
}
</style>
